module.exports = __webpack_public_path__ + "img/3.01b9c19a.jpg";